import { CheckCheck, PartyPopper, SendHorizonalIcon, Trash2 } from 'lucide-react';
import moment from 'moment';
import React from 'react';
import icEmpire from "../assets/logos/logo-empire-str.png";

const TalkTypeValidPaiement = ({ m, deleteMessage }) => {
    return (
        <div className='df fdc aic jcc w100 bcw py2 px1' style={{ borderRadius: "10px" }}>
            <div className='df aic jcsb w100'>
                <div className='df aic gap1'>
                    <div className='c-avatar'>
                        {m.role !== "user" && (
                            <img className='avatar admin' src={icEmpire}></img>
                        )}

                    </div>
                    <div className='df fdc'>
                        <div className='df gap1 aic'>
                            <SendHorizonalIcon color={'#0074dc'} size={20} />
                            <p style={{ fontSize: "0.8em" }} className='fr cb tal'>{moment(m.date).fromNow()}</p>
                        </div>
                        {m.status == "Lu" && (
                            <div className='df gap1 aic'>
                                <CheckCheck color={'#0074dc'} size={20} />
                                <p style={{ fontSize: "0.8em" }} className='fr cb tal'>{moment(m.date_read).fromNow()}</p>
                            </div>
                        )}
                    </div>
                </div>

                <div>
                    <button onClick={deleteMessage}><Trash2 color='#f71717' size={20} /></button>
                </div>
            </div>
            <PartyPopper color='#000' size={20} />
            <p className='fb cb fs1 tac py1'>Compte utilisateur est activé</p>
            <p className='fr tac fs08'>{m.message}</p>
        </div>
    );
};

export default TalkTypeValidPaiement;